module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/f4e63fb7cb118bab08e27fcc1df42750.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_results.svg
// module id = W+9S
// module chunks = 0